import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { useSectionContext } from "@repoflow/components/section";
import { useLoad } from "@repoflow/components/json";
import { Link } from "react-router-dom";
import * as BucketLib from "@common/code/bucket";
import * as FileUtils from "@repoflow/common/file-utils";
import _ from "lodash";
import * as Loading from "@repoflow/components/loading";
import { isPublic } from "@common/schema/bucket-file/visibility";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>View</BreadcrumbItem>
  </>
);

export const Content = (props) => {
  const { base, values: file } = useSectionContext();
  const { ext } = file;


  return <Container className="mt-4">

    <PublicUrl {...props} />

    <Row>
      <Col>
        <Link
          className={"btn btn-primary mt-2"}
          to={`${base}/edit`}
        >
          Edit
        </Link>{" "}
        <Link
          className={"btn btn-danger mt-2"}
          to={`${base}/remove`}
        >
          Remove
        </Link>

      </Col>
    </Row>

    {FileUtils.isZipExt(ext) && <ZipContent {...props} />}
    {FileUtils.isImageExt(ext) && <MinimapContent {...props} />}
  </Container>



};




// Shown only when the file is public, and what it shows is the URL itself.
//
// A person who has just made a file public needs the string they are going to
// paste into a page, and there is nowhere else to get it: the URL is assembled
// from two ids, neither of which is on this screen. Hidden entirely when the
// file is private, rather than shown greyed out — an anonymous GET of that URL
// is a 401, so displaying it would be offering a link that does not work.
//
// The note about the delay is not decoration. Turning a file back to private
// does not revoke a copy the CDN has already handed out; the `file/*` behaviour
// caps that at five minutes (Cache-Control: max-age=300, and the behaviour's own
// MaxTTL is 300), and that is a number somebody flipping a file back needs to
// have been told. docs/bucket-file-visibility.md carries the mechanism.
const PublicUrl = ({
  match: {
    params: { bucketId, fileId },
  },
}) => {
  const { values: file } = useSectionContext();

  if (!isPublic(file)) {
    return null;
  }

  // Absolute, because the point of showing it is that it gets pasted somewhere
  // that is not this app. `getFileUrl` returns a path; the app and the /file/
  // route are behaviours of the same distribution, so the origin is this one.
  const url = `${window.location.origin}${BucketLib.getFileUrl(bucketId, fileId, file.ext)}`;

  return (
    <Row>
      <Col>
        <div className="alert alert-info mt-2">
          <div>
            This file is <strong>public</strong>: anyone with the link below can
            read it, with no sign-in.
          </div>
          <code className="d-block mt-2">{url}</code>
          <small className="d-block mt-2">
            Making it private again takes effect within five minutes — copies
            already served keep working until then.
          </small>
        </div>
      </Col>
    </Row>
  );
};

const ZipContent = ({
  match: {
    params: { bucketId, fileId },
  },
}) => {
  const listJsonUrl = BucketLib.getUnzippedUrl(
    bucketId,
    fileId,
    'files.json'
  )

  const { data: files } = useLoad(listJsonUrl);

  if (!files) {
    return <div className="mt-4">
      <Loading.Content />
    </div>;
  }

  return (

    <>
      <Row>
        <Col>
          <ul>
            {_.map(files, ({ path }) => (
              <li key={path}>
                <a
                  href={`${BucketLib.getUnzippedUrl(
                    bucketId,
                    fileId,
                    `files/${path}`
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {path}
                </a>
              </li>
            ))}
          </ul>
        </Col>
      </Row>


    </>

  );
};


const MinimapContent = ({
  match: {
    params: { bucketId, fileId },
  },
}) => {
  const { values: file } = useSectionContext();
  const { ext, metadata } = file;

  return (

    <>
      <Row>
        <Col>
          <img
            data-zoom="85"
            className="w-100 p-2"
            alt=""
            src={BucketLib.getFileUrl(bucketId, fileId, ext)}
          />
        </Col>
        <Col>
          <ul>
            {_.map(metadata.sizes, ({ type }) => (
              <li key={type}>{type}</li>
            ))}
          </ul>
        </Col>
      </Row>
    </>

  );
};
